"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _baseService = _interopRequireDefault(require("@/config/base-service"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AssetsService = /*#__PURE__*/function (_BaseService) {
  function AssetsService() {
    var _this;
    _classCallCheck(this, AssetsService);
    _this = _callSuper(this, AssetsService, ["assets"]);
    _defineProperty(_this, "create", function (payload) {
      return _this.post(payload, '');
    });
    return _this;
  }
  _inherits(AssetsService, _BaseService);
  return _createClass(AssetsService, [{
    key: "fetchItem",
    value: function fetchItem(id) {
      return this.get("detail/".concat(id));
    }
  }, {
    key: "fetchAll",
    value: function fetchAll(params) {
      return this.get("all", {
        params: params
      });
    }
  }, {
    key: "update",
    value: function update(payload, id) {
      return this.put(payload, "".concat(id));
    }
  }, {
    key: "fetchServicesToBu",
    value: function fetchServicesToBu(idBusinessUnit) {
      return this.get("businessUnits/list/".concat(idBusinessUnit));
    }
  }, {
    key: "fetchDocumentsSevices",
    value: function fetchDocumentsSevices(id) {
      return this.get("documents/list/".concat(id));
    }
  }, {
    key: "fetchServicesActives",
    value: function fetchServicesActives(days) {
      return this.get("list-services/actives/".concat(days));
    }
  }, {
    key: "joinToConsumer",
    value: function joinToConsumer(payload) {
      return this.post(payload, 'join/consumer');
    }
  }, {
    key: "deleteServiceLinkToConsumer",
    value: function deleteServiceLinkToConsumer(id) {
      return this.delete("delete/link/".concat(id));
    }
  }, {
    key: "fetchDataSandBoxService",
    value: function fetchDataSandBoxService(id) {
      return this.get("sandbox/data/".concat(id));
    }
  }, {
    key: "updateServiceConsumerBusinessUnit",
    value: function updateServiceConsumerBusinessUnit(id, payload) {
      return this.put(payload, "businessUnits/edit/".concat(id));
    }
  }, {
    key: "fetchDataProcessingConsumerServiceToDigitalAsset",
    value: function fetchDataProcessingConsumerServiceToDigitalAsset(params) {
      return this.get("businessUnits/data-processing", {
        params: params
      });
    }
  }, {
    key: "fetchDetailDocumentationService",
    value: function fetchDetailDocumentationService(id, params) {
      return this.get("documentation/".concat(id), {
        params: params
      });
    }
  }]);
}(_baseService.default);
var _default = exports.default = new AssetsService();